import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputDateUI from '../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputCheckBoxUI from '../../../widgets/form/InputCheckBoxUI'
import './LoanCreateModal.css'

const ProjectUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onUpdateClick, onCancelUpdate,
  // form fields
 vehicleType,onVehicleTypeChange,vehicleTypeError,setVehicleTypeError,vehicleTypeList,
 vehicleCount,onVehicleCountChange,vehicleCountError,setVehicleCountError,vehicleCountList,


}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update vehicle type'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelUpdate}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onUpdateClick}
    busy={submitted}
  >
    <div className='g_flex_h g_flex_top c_ln_crt'>
      <div className='col'>
        <InputSelectSF type='select' name='vehicleType' required={true} 
          label='Vehicle type' autoFocus={true} optionList ={vehicleTypeList}
          value={vehicleType} onChange={onVehicleTypeChange} 
          error={vehicleTypeError} setError={setVehicleTypeError}
        />
        <InputTextSF type='text' name='vehicleCount' label='Vehicle count'
          value={vehicleCount} onChange={onVehicleCountChange}
          error={vehicleCountError} setError={setVehicleCountError}
        />
      </div>
    </div>
  </ModalFormUI>

export default ProjectUpdateModalUI
